import ProfileHeader from './ProfileHeader';
import ProfileBody from './ProfileBody';

export {
    ProfileHeader,
    ProfileBody,
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/index.js